import { render, staticRenderFns } from "./AddEditModifier.vue?vue&type=template&id=44ffc6ae&scoped=true&"
import script from "./AddEditModifier.vue?vue&type=script&lang=ts&"
export * from "./AddEditModifier.vue?vue&type=script&lang=ts&"
import style0 from "./AddEditModifier.vue?vue&type=style&index=0&id=44ffc6ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ffc6ae",
  null
  
)

export default component.exports